import {Link} from "react-router-dom";
import {useEffect, useState} from "react";

const SingleJobListView = (props) => {

    const[deleteClickCounter, setDeleteClickCounter] = useState(0);
   const[hasBeenSelected, setHasBeenSelected] = useState(false);
   const[language, setLanguage] = useState('en');

   useEffect(() => {
       setLanguage(props.lang);
   },[language]);

   const handleClickCounter = () => {
       console.log('Handle Click Counter!');
       setHasBeenSelected(true);
       setDeleteClickCounter(counter => counter + 1);

       setTimeout(() => {
           setDeleteClickCounter(0);
           setHasBeenSelected(false);
       }, 3000);

       if(deleteClickCounter + 1  === 2){
           props.handleDelete(props.id);
       }
   }


   const buttonClassName = `delete-button border-2 rounded-lg ${hasBeenSelected ? 'bg-red-600 text-white' : ''}`;

    // console.log('SingleJobListprops ' , props);
    //Return an element with Job title and possiblity to edit the jobs
    return(
        <div id={props.id} className={'m-1 p-1 border-2 border-green-700 max-w-sm rounded-lg'}>
            <h1>{props.job.fieldData.name}</h1>
            {/*<p>{props.id}</p>*/}
            <div className={'flex gap-2' }>
                <Link to={`/job-form/${language}/${props.id}`} className="edit-button p-1 border-2 rounded-lg">
                    Edit
                </Link>
                <button className={buttonClassName} onClick={handleClickCounter}>
                    Delete
                </button>
            </div>
        </div>
    );
}


export default SingleJobListView;